var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { attrs: { dense: "" } },
    [
      _vm._l(_vm.navLinks, function(item, i) {
        return _vm.rules.length > 0
          ? [
              item.children
                ? _c(
                    "v-list-group",
                    {
                      attrs: { value: true, "prepend-icon": item.icon },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function() {
                              return [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.title))
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._l(item.children, function(child) {
                        return child.gate === undefined ||
                          _vm.checkGate(child.gate)
                          ? _c(
                              "v-list-item",
                              {
                                key: child.title,
                                attrs: { to: child.path, link: "" }
                              },
                              [
                                _c("v-list-item-content", [
                                  _vm._v("\n          " + _vm._s(child.title))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : item.gate === undefined || _vm.checkGate(item.gate)
                ? _c(
                    "v-list-item",
                    { key: "item-" + i, attrs: { to: item.path, link: "" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-content", [
                        _vm._v("\n        " + _vm._s(item.title))
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }